import * as API from '@/api';
import {getField, updateField} from 'vuex-map-fields';
import DEFINES from '@/defines';

function initialState () {
  return {
    list: null,
  };
}

const state = initialState ();

// getters
const getters = {
  getField,
  list: state => {
    return state.list;
  },
};

// actions
const actions = {
  async get (context, payload) {
    var response = await API.adminConsumer.get (payload);
    return response;
  },

  async update (context, payload) {
    var response = await API.adminConsumer.update (payload);
    return response;
  },

  async getConsumerList (context, payload) {
    var response = await API.adminConsumer.getConsumerList (payload);
    return response;
  },

  /** Get all consumers available on company */
  async getAllConsumerList (context, payload) {
    var response = await API.adminConsumer.getAllConsumerList (payload);
    context.commit ('set_list', {
      consumers: response.consumers.data,
    });
    return response;
  },

  async showPassword (context, payload) {
    var response = await API.adminConsumer.showPassword (payload);
    return response;
  },

  async sendReminders (context, payload) {
    var response = await API.adminConsumer.sendReminders (payload);
    return response;
  },

  async detachConsumer (context, payload) {
    var response = await API.adminConsumer.detachConsumer (payload);
    return response;
  },

  async detachAllConsumer (context, payload) {
    var response = await API.adminConsumer.detachAllConsumer (payload);
    return response;
  },

  async createByAdmin (context, payload) {
    var response = await API.adminConsumer.createByAdmin (payload);
    return response;
  },

  async exportReport (context, payload) {
    var response = await API.adminConsumer.exportReport (payload);
    return response;
  },

  async exportAllConsumersReport (context, payload) {
    var response = await API.adminConsumer.exportAllConsumersReport (payload);
    return response;
  },

  async deleteConsumerDetails(context,payload) {
      return await API.adminConsumer.deleteConsumerDetails(payload);
  }
};

// mutations
const mutations = {
  updateField,
  reset (state) {
    // acquire initial state
    const s = initialState ();
    Object.keys (s).forEach (key => {
      state[key] = s[key];
    });
  },

  set_list (state, payload) {
    state.list = payload.consumers;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
